export const optionsSortEventsCountBeats = [
  undefined,
  'durAsc',
  'durDesc',
  'asc',
  'desc',
  'hrAsc',
  'hrDesc',
];
export const optionsSortEventsRhythm = [undefined, 'asc', 'desc', 'hrAsc', 'hrDesc'];
export const optionsSortDuration = [undefined, 'asc', 'desc'];

/**
 * Expands a sort dropdown key back into the sort field and direction the events query uses. The plain asc and desc keys resolve to duration or countBeats depending on the duration flag, the hr keys to avgHr and the dur keys to duration, with an empty object for anything unrecognised.
 *
 * @param key - The dropdown key to expand.
 * @param isDuration - Whether a plain asc or desc key means duration rather than beat count.
 * @returns An object carrying sortBy and newSortOrder, empty for an unknown key.
 */
export const getSortOrderAndSortBy = (key: any, isDuration: any) => {
  switch (key) {
    case 'asc':
      return {
        sortBy: isDuration ? 'duration' : 'countBeats',
        newSortOrder: 'asc',
      };
    case 'desc':
      return {
        sortBy: isDuration ? 'duration' : 'countBeats',
        newSortOrder: 'desc',
      };
    case 'hrAsc':
      return {
        sortBy: 'avgHr',
        newSortOrder: 'asc',
      };
    case 'hrDesc':
      return {
        sortBy: 'avgHr',
        newSortOrder: 'desc',
      };
    case 'durAsc':
      return {
        sortBy: 'duration',
        newSortOrder: 'asc',
      };
    case 'durDesc':
      return {
        sortBy: 'duration',
        newSortOrder: 'desc',
      };
    default:
      return {};
  }
};

/**
 * Maps a sort field and direction onto the single key the events sort dropdown is driven by. Beat counts and durations outside count-beats mode collapse to plain asc or desc, average HR maps to hrAsc or hrDesc, and duration in count-beats mode maps to durAsc or durDesc.
 *
 * @param sortBy - The sort field, one of countBeats, avgHr or duration.
 * @param sortOrder - The direction, asc or desc.
 * @param isCountBeatsMode - Whether the list is showing beat counts, which gives duration its own keys.
 * @returns The dropdown key, or undefined for an unrecognised sort field.
 */
export const getKeyBySortOrderAndSortBy = (sortBy: any, sortOrder: any, isCountBeatsMode: any) => {
  if (sortBy === 'countBeats') {
    return sortOrder === 'asc' ? 'asc' : 'desc';
  }
  if (sortBy === 'avgHr') {
    return sortOrder === 'asc' ? 'hrAsc' : 'hrDesc';
  }
  if (sortBy === 'duration') {
    if (isCountBeatsMode) {
      return sortOrder === 'asc' ? 'durAsc' : 'durDesc';
    }
    return sortOrder === 'asc' ? 'asc' : 'desc';
  }
  return undefined;
};
